import { Center } from "@chakra-ui/react";
import { DefaultTemplate } from "../../components/templates";
import { JobComponent } from "../../components/jobs/job";
import { JobListComponent } from "../../components/jobs/jobs.list";

export const JobsPage = () => {
  return (
    <DefaultTemplate>
      {/* <JobComponent /> */}
      <JobListComponent />
      <Center></Center>
    </DefaultTemplate>
  );
};
